import React from "react";
import Layout from "components/common/Layout";
import Event, {
  EventParams,
  EventProps,
  EventQuery,
  EventQueryVariables,
  EVENT_QUERY,
  getEventVariables,
} from "components/events/Event";
import { SeoPageProps } from "helpers/seo";
import { withEnhancedServerSideProps } from "helpers/withEnhancedProps";

const EventPage = ({ seo }: EventProps & SeoPageProps) => {
  return (
    <Layout initialMeta={seo}>
      <Event />
    </Layout>
  );
};

export default EventPage;

export const getServerSideProps = withEnhancedServerSideProps<
  EventProps & SeoPageProps,
  EventParams
>(async ctx => {
  if (ctx.isInitialRequest) {
    const result = await ctx.apolloClient.query<EventQuery, EventQueryVariables>({
      query: EVENT_QUERY,
      variables: getEventVariables(ctx.params || {}),
    });

    return {
      props: {
        seo: result?.data?.event?.seo,
        title: result.data.event?.title || "",
      },
    };
  }

  return { props: { title: "" } };
});
